export function formatCardNumber(value: string): string {
  const digits = value.replace(/\D/g, '')
  const formatted = digits.match(/.{1,4}/g)?.join(' ') || digits
  return formatted.slice(0, 19)
}

export function formatCVV(value: string): string {
  return value.replace(/\D/g, '').slice(0, 4)
}

export function getExpiryMonthOptions() {
  return Array.from({ length: 12 }, (_, i) => {
    const month = i + 1
    return { value: String(month).padStart(2, '0'), label: String(month).padStart(2, '0') }
  })
}

export function getExpiryYearOptions() {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: 20 }, (_, i) => {
    const year = currentYear + i
    return { value: String(year), label: String(year) }
  })
}

export function sanitizePartialPaymentInput(raw: string): string {
  const value = raw.replace(/[^0-9.]/g, '')
  const parts = value.split('.')
  const filteredValue = parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : value
  const decimalParts = filteredValue.split('.')
  return decimalParts.length > 1 && decimalParts[1].length > 2
    ? decimalParts[0] + '.' + decimalParts[1].substring(0, 2)
    : filteredValue
}
